<script setup lang="ts">
import LoginLayout from '@/onenetwork/layouts/LoginLayout.vue';
import { useAuthStore } from '@/onenetwork/stores/onenetwork.store.auth.ts';
import { Icon } from '@iconify/vue';
import { yupResolver } from '@primevue/forms/resolvers/yup';
import { useToast } from 'primevue/usetoast';
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as yup from 'yup';

const authStore = useAuthStore()

const toast = useToast();


const router = useRouter()
const route = useRoute();

const formRef = ref<any>(null);
const initialValues = ref({
  phone_number: route.query.phone_number,
  password: '',
  password_confirmation: '',
});

const schemaYup = yup.object().shape({
  password: yup.string().required('Mật khẩu không được để trống').min(8, 'Mật khẩu phải có ít nhất 8 ký tự'),
  password_confirmation: yup.string().required('Xác nhận mật khẩu không được để trống').oneOf([yup.ref('password')], 'Mật khẩu không khớp'),
});

const resolver = yupResolver(schemaYup);

const loading = ref(false)

const onFormSubmit = ({values, valid}: any) => {
  if(!valid) return;
  try{
    const formData = {
      phone_number: route.query.phone_number as string,
      password: values.password,
      password_confirmation: values.password_confirmation,
    };
    loading.value = true
    authStore.resetPW(formData).then((res) => {
      toast.add({ severity: 'success', summary: 'Thiết lập mật khẩu thành công', detail: `Thiết lập mật khẩu thành công, vui lòng đăng nhập lại`, life: 2000 });
      setTimeout(() => {
        loading.value = false
        router.push('/auth/login');
      }, 1000)
    })
  } catch (e) {
    loading.value = false
    toast.add({ severity: 'error', summary: 'Thiết lập mật khẩu thất bại', detail: `Thiết lập mật khẩu thất bại, vui lòng thử lại`, life: 2000 });
  }
};
</script>

<template>
<div class="auth-page flex w-[100vw] h-[100vh] flex-col md:flex-row items-center">
  <LoginLayout />
  <div class="flex flex-1 h-[100vh] p-5 justify-center flex-col px-[16px]">
    <Form v-slot="$form"
          :initial-values="initialValues"
          ref="formRef"
          :resolver="resolver"
          @submit="onFormSubmit" class="w-full md:w-[20vw] mx-auto ">
      <h3 class="font-bold text-xl mb-3">Thiết lập mật khẩu mới</h3>
      <div class="flex flex-col mb-3">
        <div class="flex-1 text-[12px] mb-1">Mật khẩu mới:</div>
        <div class="flex-1">
          <InputText name="password" type="password"  class="form-control py-[7px]" />
          <Message v-if="$form.password?.invalid" severity="error"  variant="simple">{{ $form.password.error.message }}</Message>
        </div>
      </div>
      <div class="flex flex-col mb-3">
        <div class="flex-1 text-[12px] mb-1">Xác nhận mật khẩu mới:</div>
        <div class="flex-1">
          <InputText name="password_confirmation" type="password"  class="form-control py-[7px]" />
          <Message v-if="$form.password_confirmation?.invalid" severity="error"  variant="simple">{{ $form.password_confirmation.error.message }}</Message>
        </div>
      </div>
      <div class="flex justify-between items-center">
        <Button type="submit" class="px-[40px] py-[10px] bg-[#ff6f00] text-white hover:bg-[#1E88E5] cursor-pointer" :disabled="loading">
          Thiết lập mật khẩu <Icon icon="eos-icons:three-dots-loading" v-if="loading" />
        </Button>
        <div class="!ml-5">
          <router-link to="/auth/verify-otp" class="hover:text-slate-700 text-[12px]">Quay về</router-link>
        </div>
      </div>
    </Form>
    <br/>
    <br/>
    <br/>
  </div>
</div>
</template>

<style scoped>

</style>
